import { COUNTRY_CODE, DEFAULT_STATE_INFO } from '../../libs/constants';
import deal from '../actions/deal';
import { updateObject, } from './../../utils/utility';

const emptyState = {
    countryLegalEntityList: {},
    quoteId: null,
    fileUploadStatus: false,
    fileUploadStatusDesc: "",
    orderType: "2",
    specialLogistics: "N",
    onsiteProcessing: "N",
    activeDeal: false,
    orderDetails: {
        selectedCountry: "",
        selectedLegalEntity: ""
    },
    ctOrderDetails: {
        selectedCountry: "",
        selectedLegalEntity: "",
        selectedCompany: ""
    },
    collectionInfoData: {
        addressId: "",
        email: "",
        contactNo: "",
        cellPhoneNumber: "",
        firstName: "",
        lastName: "",
        company: "",
        addressLine1: "",
        addressLine2: "",
        streetType: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        staircase: "",
        door: "",
        city: "",
        state: DEFAULT_STATE_INFO && DEFAULT_STATE_INFO.id,
        country: COUNTRY_CODE,
        zipCode: "",
        personalTaxId: "",
        companyTaxId: "",
        envId: "",
        comment: "",
        shippingAndReceivingHours: "",
        wasteProducerRegistration: false,
        emanifestCode: "",
        consent: false,
        subscription: false,
        surveyConsent: false,
        saveAddress: false,
        formValid: false
    },
    alternativeContactSwitchCheckbox: false,
    contactData: {
        contactId: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        isNotificationEnabled: false,
        saveContact: false,
        formValid: false
    },
    additionalComments: "",
    orderConfirmationId: "",
    assets: [],
    assetList: [],
    hasExceptionalQuote: false,
    pdfURL: "",
    gradingDescription: {},
    directUserList: [],
    dealDetails: {
        dealId: "",
        dealName: "",
        countriesLegalEntities: []
    }
}
const initialState = {
    countryLegalEntityList: {},
    quoteId: null,
    fileUploadStatus: false,
    fileUploadStatusDesc: "",
    orderType: "2",
    specialLogistics: "N",
    onsiteProcessing: "N",
    activeDeal: false,
    orderDetails: {
        selectedCountry: "",
        selectedLegalEntity: ""
    },
    ctOrderDetails:{
        selectedCountry: "",
        selectedLegalEntity: "",
        selectedCompany: ""
    },
    collectionInfoData: {
        addressId: "",
        email: "",
        contactNo: "",
        cellPhoneNumber: "",
        firstName: "",
        lastName: "",
        company: "",
        addressLine1: "",
        addressLine2: "",
        streetType: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        staircase: "",
        door: "",
        city: "",
        state: DEFAULT_STATE_INFO && DEFAULT_STATE_INFO.id,
        country: COUNTRY_CODE,
        zipCode: "",
        personalTaxId: "",
        companyTaxId: "",
        envId: "",
        comment: "",
        shippingAndReceivingHours: "",
        wasteProducerRegistration: false,
        emanifestCode: "",
        consent: false,
        subscription: false,
        surveyConsent: false,
        saveAddress: false,
        formValid: false
    },
    alternativeContactSwitchCheckbox: false,
    contactData: {
        contactId: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        isNotificationEnabled: false,
        saveContact: false,
        formValid: false
    },
    additionalComments: "",
    orderConfirmationId: "",
    assets: [],
    assetData: [],
    hasExceptionalQuote: false,
    pdfURL: "",
    directUserList: [],
    dealDetails: {
        dealId: "",
        dealName: "",
        countriesLegalEntities: []
    }
}

const updateDirectCheckoutField = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.hasOwnProperty(name)) {
        return updateObject(state, {
            [name]: value
        });
    }
    return state;
}

const updateDirectCheckoutOrderField = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.orderDetails.hasOwnProperty(name)) {
        return updateObject(state, {
            orderDetails: updateObject(state.orderDetails, {
                [name]: value
            })
        });
    }
    return state;
}

const updateDirectCheckoutCTOrderField = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.ctOrderDetails.hasOwnProperty(name)) {
        return updateObject(state, {
            ctOrderDetails: updateObject(state.ctOrderDetails, {
                [name]: value
            })
        });
    }
    return state;
}

const updateAddressData = (state = initialState, action) => {
    const { resetAddressId } = action;
    const { data, addressType } = action.data;
    data.addressId = resetAddressId ? "" : data.addressId;
    return updateObject(state, {
        [addressType]: updateObject(state[addressType], data)
    });
}

const updateAddressFormField = (state = initialState, action) => {
    // expects object in this format => { fieldName: fieldValue } For example { firstName: "John" }
    const { data, addressType } = action.data;

    const fieldName = Object.keys(data)[0];
    if (state[addressType].hasOwnProperty(fieldName)) {
        return updateObject(state, {
            [addressType]: updateObject(state[addressType], {
                [fieldName]: data[fieldName]
            })
        });
    }

    return state;
}

const setAlternativeContactSwitchCheckbox = (state = initialState, action) => {
    return updateObject(state, {
        alternativeContactSwitchCheckbox: action.data
    });
}

const updateContactData = (state = initialState, action) => {
    const { resetContactId } = action;
    const { data } = action.data;
    data.contactId = resetContactId ? "" : data.contactId;
    return updateObject(state, {
        contactData: updateObject(state.contactData, data)
    });
}

const updateContactFormField = (state = initialState, action) => {
    // expects object in this format => { fieldName: fieldValue } For example { firstName: "John" }
    const { data } = action.data;

    const fieldName = Object.keys(data)[0];
    if (state.contactData.hasOwnProperty(fieldName)) {
        return updateObject(state, {
            contactData: updateObject(state.contactData, {
                [fieldName]: data[fieldName]
            })
        });
    }

    return state;
}

const setAddtionalComments = (state = initialState, action) => {
    return updateObject(state, {
        additionalComments: action.data
    });
}

const setAssetList = (state = initialState, action) => {
    const { assetList } = action;
    return updateObject(state, { assetList });
}
const setHasExceptionalQuote = (state = initialState, action) => {
    return updateObject(state, {
        hasExceptionalQuote: action.data
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === "UPDATE_DIRECT_CHECKOUT_FIELD") {
        return updateDirectCheckoutField(state, action);
    }
    else if (action.type === "UPDATE_DIRECT_CHECKOUT_ORDER_FIELD") {
        return updateDirectCheckoutOrderField(state, action);
    }
    else if(action.type === "UPDATE_DIRECT_CHECKOUT_CT_ORDER_FIELD") {
        return updateDirectCheckoutCTOrderField(state, action);
    }
    else if (action.type === "UPDATE_DIRECT_CHECKOUT_ADDRESS_FORM_FIELD") {
        return updateAddressFormField(state, action);
    }
    else if (action.type === "SET_ALTERNATE_CONTACT_SWITCH_CHECKBOX") {
        return setAlternativeContactSwitchCheckbox(state, action);
    }
    else if (action.type === "UPDATE_DIRECT_CHECKOUT_CONTACT_FORM_FIELD") {
        return updateContactFormField(state, action);
    }
    else if (action.type === "UPDATE_DIRECT_CHECKOUT_CONTACT_DATA") {
        return updateContactData(state, action);
    }
    else if (action.type === "UPDATE_ADDITIONAL_COMMENT_DATA") {
        return setAddtionalComments(state, action);
    }
    else if (action.type === "UPDATE_DIRECT_CHECKOUT_ADDRESS_DATA") {
        return updateAddressData(state, action);
    }
    else if (action.type === "RESET_DIRECT_CHECKOUT") {
        return { ...emptyState, activeDeal: state.activeDeal };
    }
    else if (action.type === "SET_ASSET_LIST") {
        return setAssetList(state, action);
    }
    else if (action.type === "SET_HAS_EXCEPTIONAL_QUOTE") {
        return setHasExceptionalQuote(state, action);
    }
    else if (action.type === "SET_GRADING_DESCRIPTION") {
        return updateObject(state, {
            gradingDescription: action.data,
        });
    }
    else if (action.type === "RESET_DEAL_DETAILS") {
        return updateObject(state, {
            dealDetails: {
                dealId: "",
                dealName: "",
                countriesLegalEntities: []
            }
        });
    }
    else if (action.type === "SET_DEAL_DETAILS") {
        return updateObject(state, {
            dealDetails: {
                dealId: action.data.dealId,
                dealName: action.data.dealName,
                countriesLegalEntities: action.data.countriesLegalEntities,
            },
        });
    }
    else if (action.type === "SET_DIRECT_USER_LIST") {
        return updateObject(state, {
            directUserList: action.data,
        });
    }

    return state;
}

export default reducer;